// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const ChevronRightIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 13 20">
          <path fill="inherit" d="M2.462 20c-.487 0-.963-.147-1.368-.421a2.492 2.492 0 0 1-.907-1.122 2.536 2.536 0 0 1 .534-2.725L6.365 10 .721 4.268A2.52 2.52 0 0 1 0 2.5C0 1.837.26 1.201.72.732A2.443 2.443 0 0 1 2.463 0c.652 0 1.278.263 1.74.732l7.385 7.5a2.504 2.504 0 0 1 .72 1.768 2.534 2.534 0 0 1-.72 1.768l-7.385 7.5a2.45 2.45 0 0 1-1.74.732z"/>
        </svg>
      )
    }
  </Icon>
);

export default ChevronRightIcon;
